<template>
  <div :class="[baseCss]">
    <div :class="[`${baseCss}-content`]">
      <slot />
    </div>
    <div :class="[`${baseCss}-reflection`, 'relative', 'select-none', 'overflow-hidden']" :style="reflection">
      <div :class="[`${baseCss}-slot`, 'absolute', 'overflow-hidden', 'bottom-0', 'w-full']">
        <slot />
      </div>
      <div :class="[`${baseCss}-gradient`, 'absolute', 'top-0', 'w-full', 'bottom-0']" :style="gradient" />
    </div>
  </div>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'Reflection',
  mixins: [
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('reflection', [])
    }
  },
  computed: {
    gradient () {
      return {
        background: `linear-gradient(${this.endColor}, ${this.startColor})`
      }
    },
    reflection () {
      return {
        transform: `scaleY(-1)`,
        height: this.spread
      }
    }
  },
  props: {
    spread: {
      type: String,
      default: '128px'
    },
    startColor: {
      type: String,
      default: 'rgba(255, 255, 255, .7)'
    },
    endColor: {
      type: String,
      default: 'rgba(255, 255, 255, 1) 10%'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/reflection/reflection.vue